import { HttpClient } from "@angular/common/http";

import { Injectable } from "@angular/core";

import { environment } from "../../environments/environment";

@Injectable()
export class ClienteApiService {
  private URL: string = environment.angularJSconstants.URLAPICLIENTE;

  constructor(private http: HttpClient) {}

  public async comprovanteEntrega(idEncomenda) {
    try {
      return this.http

        .get(`${this.URL}/comprovanteEntregaEncomenda/${idEncomenda}`)

        .toPromise();
    } catch (error) {
      throw error;
    }
  }
}
